export const STATUS_TYPE = {
  0: { text: '订单创建', color: 'primary' },
  1: { text: '订单完成', color: 'success' },
  2: { text: '订单审核中', color: 'warning' },
  3: { text: '订单审核通过', color: 'success' },
  4: { text: '用户已打款', color: 'info' },
  5: { text: '商家已打款', color: 'info' },
  '-1': { text: '订单取消', color: 'info' },
  '-2': { text: '超时取消', color: 'info' },
  '-3': { text: '审核未通过', color: 'danger' },
  '-6': { text: '管理员已取消', color: 'danger' },
  '-7': { text: '商家处理超时取消', color: 'info' },
  '-4': { text: '系统异常', color: 'danger' }
};
export const TX_MAPS = {
  ETH: 'https://etherscan.io/tx/',
  BTC: 'https://btc.com/',
  USDT: 'https://www.omniexplorer.info/tx/'
};
